export default __webpack_public_path__ + "f9d341bab847796114df0ab4d0d72d5c.svg";